module.exports = __webpack_public_path__ + "media/images/bg-started-contents-bot-2a6e81a2.png";